export default "__VITE_ASSET__xdXKKBRg__"